/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CloverMakePayment } from '../models/CloverMakePayment';
import type { GetGuestPayableAmountDetails } from '../models/GetGuestPayableAmountDetails';
import type { GetPayableAmountDetails } from '../models/GetPayableAmountDetails';
import type { GroupedPaymentPlans } from '../models/GroupedPaymentPlans';
import type { PayableAmountDetails } from '../models/PayableAmountDetails';
import type { PaymentPlansWrapper } from '../models/PaymentPlansWrapper';
import type { PlanAmountUpdate } from '../models/PlanAmountUpdate';
import type { PlanConvenienceFeeUpdate } from '../models/PlanConvenienceFeeUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentService {

    /**
     * API to get grouped payment plans
     * @returns GroupedPaymentPlans Success
     * @throws ApiError
     */
    public static paymentGetGroupedPaymentPlans(): CancelablePromise<Array<GroupedPaymentPlans>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/payment/getGroupedPaymentPlans',
        });
    }

    /**
     * API to make clover payment
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static paymentMakeCloverPayment(
        requestBody?: CloverMakePayment,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/payment/clover',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get payable amount
     * @param requestBody
     * @returns PayableAmountDetails Success
     * @throws ApiError
     */
    public static paymentGetPayableAmount(
        requestBody?: GetPayableAmountDetails,
    ): CancelablePromise<PayableAmountDetails> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/payment/getPayableAmount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get guest payable amount
     * @param requestBody
     * @returns PayableAmountDetails Success
     * @throws ApiError
     */
    public static paymentGetGuestPayableAmount(
        requestBody?: GetGuestPayableAmountDetails,
    ): CancelablePromise<PayableAmountDetails> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/payment/getGuestPayableAmount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get all payment plans
     * @param page
     * @param limit
     * @returns PaymentPlansWrapper Success
     * @throws ApiError
     */
    public static paymentGetAllPaymentPlans(
        page?: number,
        limit?: number,
    ): CancelablePromise<PaymentPlansWrapper> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/payment/getAllPaymentPlans',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to update plan amount
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static paymentUpdatePlanAmount(
        requestBody?: PlanAmountUpdate,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/payment/updatePlanAmount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to update plan convenience fee
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static paymentUpdatePlanConvenienceFee(
        requestBody?: PlanConvenienceFeeUpdate,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/payment/updatePlanConvenienceFee',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

}
